import React from "react";
import { useSelector } from "react-redux";
import { clickOnElemnt, rgba } from "../../../../../helpers";
import { classNames } from "../../../../../helpers/classNames";
import { useDispatch } from "react-redux";
import {
  applyTheme,
  selectElement,
  setThemeValue,
} from "../../../../../redux/slice/themeSlice";
import ConfigsTool from "../tools/Configs.Tool";
import { useMutation } from "@tanstack/react-query";
import { siteSettingsUpdate } from "../../../../../services/siteSettingsService";
import Button from "../../../../form/Button";
import themes from "../../../../../db/themes";
import Select from "../../../../form/select/Select";
import Tabs from "../../../../elements/Tabs";
import Theme from "./Theme";
import SettingsDetails from "./SettingsDetails";

const PreviewPanel = () => {
  const dispatch = useDispatch();
  const { theme, selectedElement, status, colors } = useSelector(
    (state) => state?.themeProvider
  );

  const tabs_data = [
    {
      label: "Details",
      content: <SettingsDetails />,
    },
    {
      label: "Theme",
      content: <Theme />,
    },
  ];
  return (
    <>
      <div
        className={classNames(
          "h-16 editable-element",
          theme?.previewPanelHeader?.backgroundColor ? "" : "bg-white"
        )}
        id="previewPanelHeader"
        onClick={(e) => {
          dispatch(selectElement(clickOnElemnt({ event: e })));
        }}
        {...(theme?.previewPanelHeader?.backgroundColor && {
          style: {
            backgroundColor: rgba(theme?.previewPanelHeader?.backgroundColor),
          },
        })}
      ></div>
      <div className="p-4 max-h-[calc(100%-75px)] overflow-auto">
        <Tabs items={tabs_data} />
      </div>
    </>
  );
};

export default PreviewPanel;
